import companyLinks from './companyLinks'

export default { companyLinks }
